import ProjectPaymentActivationPage from "../../shared/project-payment-activation/ProjectPaymentActivationPage";

const ManagementProjectPaymentActivationPage = () => (
  <ProjectPaymentActivationPage source="Management" />
);

export default ManagementProjectPaymentActivationPage;
